import React from 'react';
import PropTypes from 'prop-types';

import Legend from './Legend';
import Header from './Header';
import PlayerRow from './PlayerRow';

const OnOffTable = ({ players, onSortChange, sortKey }) => (
  <div className="s-onoff__table is-fade-loaded">
    <Legend />

    <div className="stats-table__fixed-container">
      <div className="stats-table__container">
        <table className="stats-table">
          <Header onSortChange={onSortChange} sortKey={sortKey} />

          <tbody>
            {players.map(player => (
              <PlayerRow key={player.id} player={player} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

OnOffTable.propTypes = {
  players: PropTypes.array.isRequired,
};

export default OnOffTable;
